import { TESTIMONIALS } from "@/data/portfolio";
import { Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="border-b border-white/10 py-10 md:py-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-10">
          <h2 className="mt-3 font-oswald uppercase text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95]">
            What clients <span className="font-cormorant italic font-medium normal-case lowercase text-white/70">say</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.author}
              data-testid={`testimonial-${i}`}
              className="reveal border border-white/10 bg-[#070707] p-8 md:p-10 flex flex-col justify-between min-h-[340px] hover:border-[#00A0E4]/30 transition-colors"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <Quote className="text-[#00A0E4]" size={32} />
              <p className="font-cormorant italic text-xl md:text-2xl leading-snug text-white/90 mt-6">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-8 border-t border-white/10 pt-5">
                <p className="font-oswald uppercase tracking-wide text-white">{t.author}</p>
                <p className="text-white/40 text-xs uppercase tracking-widest mt-1">{t.role}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
